import React, { useEffect, useState } from 'react';
import { Section } from './ui/Section';
import { Users } from 'lucide-react';
export function TestimonialSection() {
  const [count, setCount] = useState(847);
  useEffect(() => {
    const handlePurchase = () => {
      setCount(prev => prev + 1);
    };
    window.addEventListener('purchase-notification', handlePurchase);
    return () => {
      window.removeEventListener('purchase-notification', handlePurchase);
    };
  }, []);
  return <Section background="night-950" className="border-y border-white/5" data-id="element-179">
      <div className="text-center mb-12" data-id="element-180">
        <div className="inline-flex items-center gap-2 bg-night-800 px-4 py-2 rounded-full border border-gold-500/20 mb-8" data-id="element-181">
          <Users className="w-4 h-4 text-gold-500" data-id="element-182" />
          <span className="text-gold-500 font-bold" data-id="element-183">{count}</span>
          <span className="text-slate-400 text-sm" data-id="element-184">
            people downloaded this audio this week
          </span>
        </div>

        <div className="max-w-2xl mx-auto" data-id="element-185">
          <blockquote className="text-xl md:text-2xl text-white font-serif leading-relaxed mb-6" data-id="element-186">
            <span className="text-gold-500 text-4xl leading-none align-top mr-2" data-id="element-187">
              "
            </span>
            I've spent $3,000 on sleep specialists in two years. This $7 audio
            showed me I'd been treating the wrong problem the entire time.
            <span className="text-gold-500 text-4xl leading-none align-bottom ml-2" data-id="element-188">
              "
            </span>
          </blockquote>
          <cite className="text-slate-400 not-italic font-medium block" data-id="element-189">
            — Michael R.
          </cite>
        </div>
      </div>
    </Section>;
}